const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;

export function getPublicationPdfUrl(filename: string | undefined): string | null {
  if (!filename || !SUPABASE_URL) {
    return null;
  }

  return `${SUPABASE_URL}/storage/v1/object/public/publications/${encodeURIComponent(filename)}`;
}

export function hasValidPdfUrl(pdfUrl: string | undefined): boolean {
  return !!pdfUrl && pdfUrl.trim().length > 0;
}
